import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from '../app';
import extractText from '../../common/utils/extractText';
import UserSearchResult from '../../common/components/UserSearchResult';

/**
 * The `UsersSearchSource` finds and displays user search results in the search
 * dropdown.
 */
export default class GlobalUsersSearchSource {
  constructor() {
    _defineProperty(this, "results", new Map());
    _defineProperty(this, "resource", 'users');
  }
  title() {
    return extractText(app.translator.trans('core.lib.search_source.users.heading'));
  }
  isCached(query) {
    return this.results.has(query.toLowerCase());
  }
  async search(query, limit) {
    return app.store.find('users', {
      filter: {
        q: query
      },
      page: {
        limit
      }
    }).then(results => {
      this.results.set(query, results);
      m.redraw();
    });
  }
  view(query) {
    query = query.toLowerCase();
    const results = (this.results.get(query) || []).concat(app.store.all('users').filter(user => [user.username(), user.displayName()].some(value => value.toLowerCase().substr(0, query.length) === query))).filter((e, i, arr) => arr.lastIndexOf(e) === i).sort((a, b) => a.displayName().localeCompare(b.displayName()));
    if (!results.length) return [];
    return results.map(user => m(UserSearchResult, {
      user: user,
      query: query
    }));
  }
  customGrouping() {
    return false;
  }
  fullPage(query) {
    return null;
  }
  gotoItem(id) {
    const user = app.store.getById('users', id);
    if (!user) return null;
    return app.route.user(user);
  }
}
flarum.reg.add('core', 'forum/components/GlobalUsersSearchSource', GlobalUsersSearchSource);